// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:45:17+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            afade2c873219795095fb5a6c713e81e
//    Signature:      eyJpdiI6ImpXZjZCV21cL3ZsUTRMb0ZaZU12ZHh3PT0iLCJ2YWx1ZSI6ImxoSDZXTlQzSDAzNUhwMW5UMnlxQ0R5WTJGMkFPcjF2ODhNbXZJZER2Y2RXTkFUR040cW9mYVVpMzRQTEpoRldDS2dhVHllRk9ycFdcL1oxQ3BrZlU4QzRFXC9YbmQ5QkRcL0RudVM1Y0ZobE5OSmJJcm5kazVjNDBXc2tWejAzbXFiNEVuenhuVjNiXC82NDhrWEFMYm1CSlwvXC9SMVBxMEtydThVRDhQYjJUYXZJSlRWd0x0cEFKKzltMFJKTERGUUsyVEQ3aE02dWJ0Z3RQc3pYekVnTGZmbUcxTzlNMnNVU3U3S01vNWpueFFxZmdwSFFsQjRNSTBVUUFBNXNnSTR5XC9EenBkWjVWOW43Z0liN3hCb2I2WmZhazJWU2VwMmhya1R2QzVJSlBOYjQ0MFQxSnFmU1hQRHNhNDJcL1dZXC82UllpaERBcWIydTdiNFU2M01nQk5ZcTFpKytNZ3dobEp3M2hYYk5LRUEzU2F1WUJrWDdGRUx0RGZyclBObTdJZmVYa3EyT3V2bko1dTZHNndBQXlpQ1ZJaHc9PSIsIm1hYyI6ImMyZWJjNTZmM2NiZmZmZWI4ODI4NjcwZmI0MGY1YjQwODE4ODM2OTZmZmQ4YmEyYWRjY2I4MjVhYjQwZjQyYmYifQ==
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
